import { makePercent, Percent } from "@silo/types";
import { pipe } from "effect";
import { BaseFutureProjections } from "../base-future-projections";
import { UtilizationState } from "@silo/utils";

interface FutureProjectionsProps {
  debtBaseApr1d: Percent;
  debtBaseApr3d: Percent;
  totalDebtRewardsApr: Percent;
  utilizationState: UtilizationState;
}

export function FutureProjections({
  debtBaseApr1d,
  debtBaseApr3d,
  totalDebtRewardsApr,
  utilizationState,
}: FutureProjectionsProps): JSX.Element {
  const totalApr1d = pipe(debtBaseApr1d - totalDebtRewardsApr, makePercent);
  const totalApr3d = pipe(debtBaseApr3d - totalDebtRewardsApr, makePercent);

  return (
    <BaseFutureProjections
      totalApr1d={totalApr1d}
      totalApr3d={totalApr3d}
      utilizationState={utilizationState}
    />
  );
}
